
import Handlebars from "handlebars/dist/handlebars.js";
import "../utils";

var associationpicker = (function () {
    "use strict";

    function openSearchHandler(e) {
        if ($(".search-association").length == 0) {
            e.preventDefault();
            var $this = $(this),
                data = $this.data(),
                source = $('#' + data.template).html(),
                template = Handlebars.compile(source),
                html = template();

            $('.modal').append(html);
        }
    }

    function searchAssociationHandler(e) {
        e.preventDefault();

        var searchText = $('.search-association #association').val();

        window.fsSearch.searchAssociation(searchText)
            .then(handleSearchResult, handleSearchError)
            .catch(error => {
                console.log(`error: ${error}`);
            });
    }

    var handleSearchError = function (error) {
        var $resultPanel = $('.search-association .right');

        $resultPanel.empty().append(error);
    }

    var handleSearchResult = function (resultList) {

        var $searchBtn = $('.search-association #search'),
            $resultPanel = $('.search-association .right'),
            source = $('#' + $searchBtn.data('template')).html(),
            template = Handlebars.compile(source)

        var html = template(resultList.rawResults);
        $resultPanel.empty().append(html);
    }

    function pickAssociationHandler(e) {
        e.preventDefault();

        var $this = $(this),
            pickedWrapper = $('.picked-association'),
            checked = $this.parent().find('input[type="radio"]:checked'),
            data = checked.data(),
            source = $('#picked-association-template').html(),
            template = Handlebars.compile(source),
            html = template({ Name: data.name, City: data.city });

        pickedWrapper.empty().append(html);
        $('#association-id').val(data.id).trigger('change');
        $('#association-number').val(data.number).trigger('change');;
        $('#association-name').val(data.name);
    }

    if ($('.associationpicker').length > 0) {

        var customerId = Utils.GetUrlParamByName("customerid");
        if (customerId !== "") {
            $.ajax({
                url: SETTINGS.services.site.methods.findAssociation,
                data: JSON.stringify({ accountId: customerId }),
                success: function (data) {
                    if (data.Success && data.Data.length === 1) {
                        var source = $('#picked-association-template').html(),
                            template = Handlebars.compile(source),
                            html = template({ Name: data.Data[0].Name, City: data.Data[0].City });

                        $('.picked-association').empty().append(html);
                        $('#association-id').val(data.Data[0].Id).trigger('change');
                        $('#association-name').val(data.Data[0].Name);
                    }
                }
            });

        }

        $('body').on('click', '.associationpicker .search-link', openSearchHandler);
        $('body').on('click', '.search-association #search', searchAssociationHandler);
        $('body').on('click', '.search-association #pick-association', pickAssociationHandler);

        $('body').on('keyup', '#association', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                $(this).next().trigger('click');
                return false;
            }
        });
    }
})();